import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { displayPhoneBR } from '../lib/phone';
import LiveBanner from './LiveBanner';

export default function Layout() {
  const { user, logout, isAdmin } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen">
      <header className="bg-brand-500 text-white shadow sticky top-0 z-10">
        <div className="max-w-5xl mx-auto px-3 sm:px-4 py-2 sm:py-3 flex flex-wrap items-center justify-between gap-y-2">
          <NavLink
            to="/"
            className="font-bold text-base sm:text-lg shrink-0 hover:opacity-80"
          >
            Bolão Copa 2026 🏆
          </NavLink>
          <div className="text-sm sm:text-xs order-3 sm:order-2 ml-auto sm:ml-0 flex items-center gap-2">
            <span className="hidden sm:inline">{user?.name || displayPhoneBR(user?.phone_number)}</span>
            <button
              onClick={() => {
                logout();
                navigate('/login');
              }}
              className="px-3 py-1.5 sm:px-2 sm:py-1 rounded bg-white/15 hover:bg-white/25 active:bg-white/30 transition"
            >
              Sair
            </button>
          </div>
          <nav className="order-2 sm:order-3 w-full sm:w-auto flex justify-around sm:gap-4 text-base sm:text-sm border-t sm:border-0 pt-1 sm:pt-0 -mx-3 sm:mx-0 px-1 sm:px-0">
            {[
              { to: '/', label: 'Bolões', end: true },
              { to: '/regulamento', label: 'Regulamento' },
              { to: '/pix', label: user?.pix_key ? 'Alterar Pix' : 'Cadastrar Pix' },
              ...(isAdmin ? [{ to: '/admin', label: 'Admin' }] : []),
            ].map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.end}
                className={({ isActive }) =>
                  `px-3 py-2.5 sm:px-2 sm:py-1 rounded transition ${
                    isActive
                      ? 'bg-white/20 font-bold'
                      : 'hover:bg-white/10 active:bg-white/20'
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>
        </div>
      </header>
      <LiveBanner />
      <main className="max-w-5xl mx-auto px-3 sm:px-4 py-4 sm:py-6">
        <Outlet />
      </main>
    </div>
  );
}
